var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc wordcloud
 */
import { createRef } from '@byted/light-render';
import { Group, createText } from '../../element';
import { SeriesModel } from '../../model';
import { LegendType } from '../../interface/legend';
import { registerChart } from '../index';
import { wordcloudLyaout } from './wordcloud-layout';
import { interpolateNumber } from '../../utils/math';
var WordCloud2 = /** @class */ (function (_super) {
    __extends(WordCloud2, _super);
    function WordCloud2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'wordCloudFast';
        _this.legendIcon = 'rect';
        _this.legendType = LegendType.DATUM_LEGEND;
        return _this;
    }
    WordCloud2.prototype.getDefaultOption = function () {
        return {
            type: 'wordCloudFast',
            name: '',
            encode: {
                name: '',
                value: '',
            },
            sizeRange: [12, 60],
            maskImage: null,
            shape: 'circle',
            gridSize: 8,
            ellipticity: 0.65,
            zoomToFit: false,
            formatter: function (point) { return point.name; },
            textStyle: {
                color: null,
                fontSize: null,
                fontWeight: 'normal',
                cursor: 'pointer',
                shadowBlur: 0,
            },
            hover: {
                textStyle: {
                    color: null,
                    fontSize: null,
                    shadowBlur: 8,
                    shadowColor: 'rgba(0, 0, 0, .2)',
                },
            },
            selected: {
                textStyle: {
                    color: null,
                    fontSize: null,
                },
            },
            label: null,
            visible: true,
            showLegend: false,
            selectedMode: false,
            minRotation: 0,
            maxRotation: 0,
            rotateRatio: 0.5,
            rotationSteps: 4,
        };
    };
    WordCloud2.prototype.toggleHighlightPoint = function (dataIndex, active) {
        var _a;
        var textStyle = this.option.textStyle;
        var selectedTextStyle = this.option.selected.textStyle;
        var hoverTextStyle = this.option.hover.textStyle;
        var point = this.state.points[dataIndex];
        (_a = point.shapeRef.current) === null || _a === void 0 ? void 0 : _a.setAttr(__assign(__assign(__assign({ fill: active ? this.getHoverColor(point.color) : point.color }, this.getTextStyle(textStyle)), (point.selected ? this.getTextStyle(selectedTextStyle) : null)), (active ? this.getTextStyle(hoverTextStyle) : null)));
    };
    WordCloud2.prototype.toggleSelectPoint = function (dataIndex, selected) {
        _super.prototype.toggleSelectPoint.call(this, dataIndex, selected);
        var textStyle = this.option.textStyle;
        var selectedTextStyle = this.option.selected.textStyle;
        var point = this.state.points[dataIndex];
        point.shapeRef.current.setAttr(__assign({ fill: point.color }, this.getTextStyle(selected ? selectedTextStyle : textStyle)));
    };
    WordCloud2.prototype.beforeRender = function () {
        var _this = this;
        var dataset = this._dataset;
        var valueField = this.option.encode.value;
        var valueRange = dataset.getExtreme(valueField);
        var sizeRange = this.option.sizeRange;
        var points = dataset.mapData(function (record, dataIndex) {
            var encode = _this._encode.getEncodeData(record, dataIndex);
            var size = interpolateNumber(encode.value, valueRange, sizeRange);
            var shapeRef = createRef();
            return {
                encode: encode,
                name: encode.name,
                value: encode.value,
                size: size,
                color: encode.color,
                visible: !_this.invisibleItems.has(dataIndex),
                selected: _this.selectedItems.has(record),
                shapeRef: shapeRef,
            };
        });
        this.setState({ points: points });
    };
    WordCloud2.prototype.render = function () {
        var _this = this;
        var _a = this.option, shape = _a.shape, gridSize = _a.gridSize, ellipticity = _a.ellipticity, zoomToFit = _a.zoomToFit, minRotation = _a.minRotation, maxRotation = _a.maxRotation, rotateRatio = _a.rotateRatio, rotationSteps = _a.rotationSteps;
        var group = new Group({
            key: this.getKey('wordcloud-lite'),
        });
        var _b = this.getFacetBBox(), top = _b.top, left = _b.left, width = _b.width, height = _b.height;
        var centerX = left + width / 2;
        var centerY = top + height / 2;
        var layoutWidth = zoomToFit ? 1600 : width;
        var layoutHeight = zoomToFit ? 900 : height;
        var textList = this.state.points
            .map(function (point, dataIndex) {
            var shapeRef = point.shapeRef, color = point.color, selected = point.selected;
            return createText(__assign(__assign(__assign({ key: dataIndex, ref: shapeRef, text: _this.formatItem(_this.option.formatter, _this.getWrappedPoint(dataIndex)), fill: color }, _this.getTextStyle(_this.option.textStyle)), (selected ? _this.getTextStyle(_this.option.selected.textStyle) : null)), { fontSize: point.size, textAlign: 'center', textBaseline: 'middle', onEvent: function (event) {
                    return _this.handleUIEvent(event, 'point', {
                        point: _this.getWrappedPoint(dataIndex),
                    });
                } }));
        })
            .sort(function (a, b) { return b.getBBox().height - a.getBBox().height; });
        var words = textList.map(function (item) {
            var box = item.getBBox();
            return {
                cx: 0,
                cy: 0,
                width: box.width,
                height: box.height,
                grids: [],
                visible: false,
            };
        });
        wordcloudLyaout(words, {
            x: centerX - layoutWidth / 2,
            y: centerY - layoutHeight / 2,
            width: layoutWidth,
            height: layoutHeight,
            gridSize: gridSize,
            shape: shape,
            ellipticity: ellipticity,
            minRotation: minRotation,
            maxRotation: maxRotation,
            rotateRatio: rotateRatio,
            rotationSteps: rotationSteps,
        });
        // words.forEach((word) => {
        //   return
        //   const { grids } = word;
        //   const color = '#' + Math.random().toString(16).substr(2, 6)
        //   grids.forEach(grid => {
        //     group.add(new Rect({
        //       fill: color,
        //       lineWidth:1,
        //       stroke: 'red',
        //       opacity: 0.2,
        //       x: left + grid[0] * gridSize,
        //       y: top + grid[1] * gridSize,
        //       width: gridSize,
        //       height: gridSize,
        //     }))
        //   });
        // })
        textList.forEach(function (text, index) {
            var _a = words[index], cx = _a.cx, cy = _a.cy, visible = _a.visible, rotation = _a.rotation;
            var pointVisible = _this.state.points[index].visible;
            text.setAttr({
                display: visible && pointVisible,
                x: cx,
                y: cy,
                originX: cx,
                originY: cy,
                scaleX: 1,
                scaleY: 1,
                rotation: rotation,
                onMounted: function () {
                    if (!_this.state.needAnimation) {
                        return;
                    }
                    text.setAttr({ scaleX: 0, scaleY: 0 }).animateTo({
                        scaleX: 1,
                        scaleY: 1,
                    }, 1000);
                },
            });
            group.add(text);
        });
        // zoomtofit
        if (zoomToFit) {
            var bbox = group.getBBox();
            if (bbox.width && bbox.height) {
                var sx = width / bbox.width;
                var sy = height / bbox.height;
                var scale = Math.min(sx, sy);
                if (scale < 1) {
                    group.setAttr({
                        originX: centerX,
                        originY: centerY,
                        scaleX: scale,
                        scaleY: scale,
                    });
                }
            }
        }
        return group;
    };
    WordCloud2.dependencies = ['legend'];
    return WordCloud2;
}(SeriesModel));
export default WordCloud2;
registerChart('wordCloudFast', WordCloud2);
